export const PAGE_SIZE = 25;

export const mergeUniqueItems = (existing = [], incoming = []) => {
    const seen = new Set();
    return [...existing, ...incoming].filter((item) => {
        const key = item?.id;
        if (key == null) return true;
        const normalizedKey = String(key);
        if (seen.has(normalizedKey)) return false;
        seen.add(normalizedKey);
        return true;
    });
};

export const fetchNextPage = async ({
    fetchMore,
    field,
    items,
    offset = items?.length || 0,
    variables = {},
}) => {
    if (typeof fetchMore !== 'function') return 0;

    let received = 0;
    await fetchMore({
        variables: { ...variables, limit: PAGE_SIZE, offset },
        updateQuery: (previous, { fetchMoreResult }) => {
            const incoming = fetchMoreResult?.[field] || [];
            received = incoming.length;
            return {
                ...previous,
                [field]: mergeUniqueItems(previous?.[field], incoming),
            };
        },
    });
    return received;
};
